

export const updatePlaceholders = (fields) => {
  return fields?.length > 0 ? fields?.map((field) => {
      let placeholderText = "Enter a number (e.g., 25 for 25%)";
      return { ...field, placeholder: placeholderText };
    }) : [];
};


export const commonFilterOperators = {
  string: [
    {
      id: "equals",
      name: "Equals",
      multiple: false,
      dropdown: true,
      input: true,
      symbol: "=",
    },
    {
      id: "notEquals",
      name: "Not Equals",
      multiple: false,
      dropdown: true,
      input: true,
      symbol: "≠",
    },
    {
      id: "in",
      name: "IN",
      multiple: true,
      dropdown: true,
      input: true,
      symbol: "∈",
    },
    {
      id: "notIn",
      name: "Not IN",
      multiple: true,
      dropdown: true,
      input: true,
      symbol: "∉",
    },
    {
      id: "contains",
      name: "Contains",
      multiple: false,
      dropdown: false,
      input: true,
      symbol: "⊂",
    },
    {
      id: "notContains",
      name: "Not Contains",
      multiple: false,
      dropdown: false,
      input: true,
      symbol: "⊄",
    },
    {
      id: "startsWith",
      name: "Starts With",
      multiple: false,
      dropdown: false,
      input: true,
      symbol: "⇝",
    },
    {
      id: "notStartsWith",
      name: "Not Starts With",
      multiple: false,
      dropdown: false,
      input: true,
      symbol: "≠⇝",
    },
    {
      id: "set",
      name: "Exist",
      multiple: false,
      dropdown: false,
      input: false,
      symbol: "∃",
    },
    {
      id: "notSet",
      name: "Not Exist",
      multiple: false,
      dropdown: false,
      input: false,
      symbol: "∄",
    },
  ],
  int: [
    {
      id: "equals",
      name: "Equals",
      multiple: false,
      dropdown: false,
      input: true,
      symbol: "=",
    },
    {
      id: "notEquals",
      name: "Not Equals",
      multiple: false,
      dropdown: false,
      input: true,
      symbol: "≠",
    },
    {
      id: "gt",
      name: "Greater Than",
      multiple: false,
      dropdown: false,
      input: true,
      symbol: ">",
    },
    {
      id: "gte",
      name: "Greater Than or Equal",
      multiple: false,
      dropdown: false,
      input: true,
      symbol: "≥",
    },
    {
      id: "lt",
      name: "Less Than",
      multiple: false,
      dropdown: false,
      input: true,
      symbol: "<",
    },
    {
      id: "lte",
      name: "Less Than or Equal",
      multiple: false,
      dropdown: false,
      input: true,
      symbol: "≤",
    },
    {
      id: "set",
      name: "Exist",
      multiple: false,
      dropdown: false,
      input: false,
      symbol: "∃",
    },
    {
      id: "notSet",
      name: "Not Exist",
      multiple: false,
      dropdown: false,
      input: false,
      symbol: "∄",
    },
  ],
  date: [
    { id: "equals", name: "Equals", multiple: false, dropdown: false, input: true, symbol: "=" },
    { id: "notEquals", name: "Not Equals", multiple: false, dropdown: false, input: true, symbol: "≠" },
    { id: "afterDate", name: "After Date", multiple: false, dropdown: false, input: true, symbol: ">" },
    {
      id: "afterOrOnDate",
      name: "After or On Date",
      multiple: false,
      dropdown: false,
      input: true,
      symbol: "≥",
    },
    { id: "beforeDate", name: "Before Date", multiple: false, dropdown: false, input: true, symbol: "<" },
    {
      id: "beforeOrOnDate",
      name: "Before or On Date",
      multiple: false,
      dropdown: false,
      input: true,
      symbol: "≤",
    },
  ],
  customOnlyContins: [
    {
      id: "contains",
      name: "Contains",
      multiple: false,
      dropdown: false,
      input: true,
      symbol: "⊂",
    },
    {
      id: "notContains",
      name: "Not Contains",
      multiple: false,
      dropdown: false,
      input: true,
      symbol: "⊄",
    },
  ],
  customOnlyContinsWithSelect: [
    {
      id: "contains",
      name: "Equals",
      multiple: false,
      dropdown: true,
      input: true,
      symbol: "=",
    },
    {
      id: "notContains",
      name: "Not Equals",
      multiple: false,
      dropdown: true,
      input: true,
      symbol: "≠",
    },
  ],
};


export const FiltersMeasuresDataQuadrant = {
  amazon: {
    operators: commonFilterOperators,
    fields: [
  // Spends
  {
    name: "Spends",
    id: "VariantAnalysisTablePPMPlaceholder.cost",
    grouping: "Spends",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "cost_key",
  },
  // {
  //   name: "Spends (DRR)",
  //   id: "VariantAnalysisTablePPMPlaceholder.costDRR",
  //   grouping: "Spends",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "cost_ddr_key",
  // },

  // ROAS
  {
    name: "ROAS",
    id: "VariantAnalysisTablePPMPlaceholder.roas",
    grouping: "ROAS",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "roas_key",
  },
  // {
  //   name: "ROAS (DRR)",
  //   id: "VariantAnalysisTablePPMPlaceholder.roasDRR",
  //   grouping: "ROAS",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "roas_ddr_key",
  // },

  // Impressions
  {
    name: "Impressions",
    id: "VariantAnalysisTablePPMPlaceholder.impressions",
    grouping: "Impressions",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "impressions_key",
  },
  // {
  //   name: "Impressions (DRR)",
  //   id: "VariantAnalysisTablePPMPlaceholder.impressionsDRR",
  //   grouping: "Impressions",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "impressions_ddr_key",
  // },

  // Clicks
  {
    name: "Clicks",
    id: "VariantAnalysisTablePPMPlaceholder.clicks",
    grouping: "Clicks",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "clicks_key",
  },
  // {
  //   name: "Clicks (DRR)",
  //   id: "VariantAnalysisTablePPMPlaceholder.clicksDRR",
  //   grouping: "Clicks",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "clicks_ddr_key",
  // },

  // CPC
  {
    name: "CPC",
    id: "VariantAnalysisTablePPMPlaceholder.cpc",
    grouping: "CPC",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "cpc_key",
  },
  // {
  //   name: "CPC (DRR)",
  //   id: "VariantAnalysisTablePPMPlaceholder.cpcDRR",
  //   grouping: "CPC",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "cpc_ddr_key",
  // },

  // CTR
  {
    name: "CTR",
    id: "VariantAnalysisTablePPMPlaceholder.ctr",
    grouping: "CTR",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "ctr_key",
  },
  // {
  //   name: "CTR (DRR)",
  //   id: "VariantAnalysisTablePPMPlaceholder.ctrDRR",
  //   grouping: "CTR",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "ctr_ddr_key",
  // },

  // CPM
  {
    name: "CPM",
    id: "VariantAnalysisTablePPMPlaceholder.cpm",
    grouping: "CPM",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "cpm_key",
  },
  // {
  //   name: "CPM (DRR)",
  //   id: "VariantAnalysisTablePPMPlaceholder.cpmDRR",
  //   grouping: "CPM",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "cpm_ddr_key",
  // },

  // Conversions
  {
    name: "Ad Units",
    id: "VariantAnalysisTablePPMPlaceholder.conversions14d",
    grouping: "Units",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "conversions14d_key",
  },
  // {
  //   name: "Ad Units (DRR)",
  //   id: "VariantAnalysisTablePPMPlaceholder.conversions14dDRR",
  //   grouping: "Units",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "conversions14d_ddr_key",
  // },

  // Conversion Rate
  {
    name: "Conversion Rate",
    id: "VariantAnalysisTablePPMPlaceholder.conversion_rate",
    grouping: "Conversion Rate",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "conversion_rate_key",
  },
  // {
  //   name: "Conversion Rate (DRR)",
  //   id: "VariantAnalysisTablePPMPlaceholder.conversion_rateDRR",
  //   grouping: "Conversion Rate",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "conversion_rate_ddr_key",
  // },

  // Revenue
  {
    name: "Revenue",
    id: "VariantAnalysisTablePPMPlaceholder.sales14d",
    grouping: "Revenue",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "sales14d_key",
  },
  // {
  //   name: "Revenue (DRR)",
  //   id: "VariantAnalysisTablePPMPlaceholder.sales14dDRR",
  //   grouping: "Revenue",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "sales14d_ddr_key",
  // },

  // Average Order Value
  {
    name: "Average Order Value",
    id: "VariantAnalysisTablePPMPlaceholder.average_order_value",
    grouping: "Average Order Value",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "average_order_value_key",
  },
  // {
  //   name: "Average Order Value (DRR)",
  //   id: "VariantAnalysisTablePPMPlaceholder.average_order_valueDRR",
  //   grouping: "Average Order Value",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "average_order_value_ddr_key",
  // },

  // ACOS
  {
    name: "ACOS",
    id: "VariantAnalysisTablePPMPlaceholder.acos",
    grouping: "ACOS",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "acos_key",
  },
  // {
  //   name: "ACOS (DRR)",
  //   id: "VariantAnalysisTablePPMPlaceholder.acosDRR",
  //   grouping: "ACOS",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "acos_ddr_key",
  // },

  // BSR
  {
    name: "BSR",
    id: "VariantAnalysisTablePPMPlaceholder.BSR",
    grouping: "BSR",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "bsr_key",
  },

  // MRP
  {
    name: "MRP",
    id: "VariantAnalysisTablePPMPlaceholder.MaximumRetailPrice",
    grouping: "MRP",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "maximum_retail_price_key",
  },

  // Selling Price
  {
    name: "Selling Price",
    id: "VariantAnalysisTablePPMPlaceholder.SalePrice",
    grouping: "Selling Price",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "salePrice_key",
  },

  // Available Inventory
  {
    name: "Available Inventory",
    id: "VariantAnalysisTablePPMPlaceholder.Quantity",
    grouping: "Available Inventory",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "Quantity_key",
  },

  // TACOS
  {
    name: "Total ACOS",
    id: "VariantAnalysisTablePPMPlaceholder.tacos",
    grouping: "Total ACOS",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "tacos_key",
  },

  // ASP
  {
    name: "Total ASP",
    id: "VariantAnalysisTablePPMPlaceholder.total_asp",
    grouping: "Total ASP",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "total_asp_key",
  },

  // Total Revenue
  {
    name: "Total Revenue",
    id: "VariantAnalysisTablePPMPlaceholder.trevnue",
    grouping: "Revenue",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "trevnue_key",
  },

  // Total ROAS
  {
    name: "Total ROAS",
    id: "VariantAnalysisTablePPMPlaceholder.troas",
    grouping: "Total ROAS",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "troas_key",
  },

  // Total Units
  {
    name: "Total Units",
    id: "VariantAnalysisTablePPMPlaceholder.tunits_sold",
    grouping: "Units",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "tunits_sold_key",
  },
]
  },
  amazonCampaignABO: {
    operators: commonFilterOperators,
    fields: [
      {
        name: "Spends",
        id: "spends",
        grouping: "Spends",
        datatype: "int",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "spends_key",
      },
      {
        name: "Impressions",
        id: "impressions",
        grouping: "Impressions",
        datatype: "int",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "impressions_key",
      },
      {
        name: "Clicks",
        id: "clicks",
        grouping: "Clicks",
        datatype: "int",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "clicks_key",
      },
      {
        name: "Orders",
        id: "orders",
        grouping: "Orders",
        datatype: "int",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "orders_key",
      },
      {
        name: "Revenue",
        id: "revenue",
        grouping: "Revenue",
        datatype: "int",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "revenue_key",
      },
      {
        name: "ROAS",
        id: "roas",
        grouping: "ROAS",
        datatype: "int",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "roas_key",
      },
      {
        name: "CTR",
        id: "ctr",
        grouping: "CTR",
        datatype: "int",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "ctr_key",
      },
      {
        name: "CPC",
        id: "cpc",
        grouping: "CPC",
        datatype: "int",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "cpc_key",
      },
      {
        name: "CPM",
        id: "cpm",
        grouping: "CPM",
        datatype: "int",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "cpm_key",
      },
      {
        name: "CVR",
        id: "cvr",
        grouping: "CVR",
        datatype: "int",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "cvr_key",
      },
      {
        name: "AOV",
        id: "aov",
        grouping: "AOV",
        datatype: "int",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "aov_key",
      },
      {
        name: "ACOS",
        id: "acos",
        grouping: "ACOS",
        datatype: "int",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "acos_key",
      },
    ]
  },
  myntra: {
    operators: commonFilterOperators,
    fields: [
  {
    name: "Spends",
    id: "spends",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "spends_key",
    grouping: "Spends",
  },
  {
    name: "Impressions",
    id: "impressions",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "impressions_key",
    grouping: "Impressions",
  },
  
  // {
  //   name: "Views",
  //   id: "views",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "views_key",
  //   grouping: "Views",
  // },
  {
    name: "Clicks",
    id: "clicks",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "clicks_key",
    grouping: "Clicks",
  },
  {
    name: "Total Clicks",
    id: "total_click",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "total_click_key",
    grouping: "Total Clicks",
  },
  {
    name: "CPC",
    id: "cpc",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "cpc_key",
    grouping: "CPC",
  },
  {
    name: "CTR",
    id: "ctr",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "ctr_key",
    grouping: "CTR",
  },
  {
    name: "Ads CVR",
    id: "cvr",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "cvr_key",
    grouping: "CVR",
  },
  {
    name: "Total CVR",
    id: "total_cvr",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "total_cvr_key",
    grouping: "CVR",
  },
  {
    name: "Units (Direct)",
    id: "units_sold_direct",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "units_sold_direct_key",
    grouping: "Units",
  },
  {
    name: "Units (Indirect)",
    id: "units_sold_indirect",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "units_sold_indirect_key",
    grouping: "Units",
  },
  {
    name: "Ads Units",
    id: "orders",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "orders_key",
    grouping: "Units",
  },
   {
    name: "Total Units",
    id: "order_units",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "order_units_key",
    grouping: "Units",
  },
  {
    name: "Total Units (Partners)",
    id: "partners_total_orders",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "partners_total_orders_key",
    grouping: "Units",
  },
  {
    name: "Revenue (Direct)",
    id: "revenue_direct",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "revenue_direct_key",
    grouping: "Revenue",
  },
  {
    name: "Revenue (Indirect)",
    id: "revenue_indirect",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "revenue_indirect_key",
    grouping: "Revenue",
  },
  {
    name: "Ads Revenue",
    id: "revenue",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "revenue_key",
    grouping: "Revenue",
  },
  {
    name: "Total Revenue (GMV)",
    id: "gmv",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "gmv_key",
    grouping: "Revenue",
  },
  {
    name: "Total Revenue (Partners)",
    id: "partners_total_revenue",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "partners_total_revenue_key",
    grouping: "Revenue",
  },
  {
    name: "Total Inventory Count",
    id: "total_inventory_count",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "total_inventory_count_key",
    grouping: "Inventory",
  },
  {
    name: "Total Inventory Count (Partner)",
    id: "total_inventory_count_partner",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "total_inventory_count_partner_key",
    grouping: "Inventory",
  },
  {
    name: "ROAS Direct",
    id: "direct_roas",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "direct_roas_key",
    grouping: "ROAS",
  },
  {
    name: "Ads ROAS",
    id: "roas",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "roas_key",
    grouping: "ROAS",
  },
   {
    name: "Total ROAS",
    id: "total_roas",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "total_roas_key",
    grouping: "ROAS",
  },
  {
    name: "Revenue (Direct) Percentage",
    id: "direct_revenue_percentage",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "direct_revenue_percentage_key",
    grouping: "Revenue",
  },
  {
    name: "Revenue (Indirect) Percentage",
    id: "indirect_revenue_percentage",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "indirect_revenue_percentage_key",
    grouping: "Revenue",
  },
  {
    name: "MRP",
    id: "mrp",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "mrp_key",
    grouping: "MRP",
  },
  {
    name: "Average Selling Price (ASP)",
    id: "asp",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "asp_key",
    grouping: "ASP",
  },
  // {
  //   name: "Spends DRR",
  //   id: "spends_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "spends_drr_key",
  //   grouping: "Spends",
  // },
  // {
  //   name: "Views DRR",
  //   id: "views_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "views_drr_key",
  //   grouping: "Views",
  // },
  // {
  //   name: "Clicks DRR",
  //   id: "clicks_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "clicks_drr_key",
  //   grouping: "Clicks",
  // },
  // {
  //   name: "CTR DRR",
  //   id: "ctr_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "ctr_drr_key",
  //   grouping: "CTR",
  // },
  // {
  //   name: "CPC DRR",
  //   id: "cpc_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "cpc_drr_key",
  //   grouping: "CPC",
  // },
  // {
  //   name: "CVR DRR",
  //   id: "cvr_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "cvr_drr_key",
  //   grouping: "CVR",
  // },
  // {
  //   name: "Units (Direct) DRR",
  //   id: "units_sold_direct_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "units_sold_direct_drr_key",
  //   grouping: "Units",
  // },
  // {
  //   name: "Units (Indirect) DRR",
  //   id: "units_sold_indirect_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "units_sold_indirect_drr_key",
  //   grouping: "Units",
  // },
  // {
  //   name: "Revenue (Direct) DRR",
  //   id: "revenue_direct_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "revenue_direct_drr_key",
  //   grouping: "Revenue",
  // },
  // {
  //   name: "Revenue (Indirect) DRR",
  //   id: "revenue_indirect_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "revenue_indirect_drr_key",
  //   grouping: "Revenue",
  // },
  // {
  //   name: "ROAS DRR",
  //   id: "roas_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "roas_drr_key",
  //   grouping: "ROAS",
  // },
  // {
  //   name: "ASP DRR",
  //   id: "asp_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "asp_drr_key",
  //   grouping: "ASP",
  // },

  // left-over from filter (not in myntra sequence)
  {
    name: "Average Order Value",
    id: "aov",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "aov_key",
    grouping: "AOV",
  },
  {
    name: "Days on Hands (DoH)",
    id: "doh",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "doh_key",
    grouping: "Days on Hands (DoH)",
  },
  {
    name: "Velocity",
    id: "velocity",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "velocity_key",
    grouping: "Velocity",
  },
  {
    name: "Ad Sales per Impression",
    id: "ad_sales_per_impression",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "ad_sales_per_impression_key",
    grouping: "Ad Sales per Impression",
  },
  {
    name: "Revenue per Impression (RPI)",
    id: "rpi",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "rpi_key",
    grouping: "Revenue per Impression (RPI)",
  },
]
  },
  flipkart: {
    operators: commonFilterOperators,
    fields: [
  {
    name: "Spends",
    id: "spends",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "spends_key",
    grouping: "Spends",
  },
  {
    name: "Clicks",
    id: "clicks",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "clicks_key",
    grouping: "Clicks",
  },
  {
    name: "Impressions",
    id: "impressions",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "impressions_key",
    grouping: "Impressions",
  },
  {
    name: "CPC",
    id: "cpc",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "cpc_key",
    grouping: "CPC",
  },
  {
    name: "CTR",
    id: "ctr",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "ctr_key",
    grouping: "CTR",
  },
  {
    name: "Ads CVR",
    id: "cvr",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "cvr_key",
    grouping: "CVR",
  },
  {
    name: "Total CVR",
    id: "total_cvr",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "total_cvr_key",
    grouping: "CVR",
  },
  {
    name: "Units (Direct)",
    id: "units_sold_direct",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "units_sold_direct_key",
    grouping: "Units",
  },
  {
    name: "Units (Indirect)",
    id: "units_sold_indirect",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "units_sold_indirect_key",
    grouping: "Units",
  },
  {
    name: "Ads Units",
    id: "orders",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "orders_key",
    grouping: "Units",
  },
  {
    name: "Total Units",
    id: "order_units",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "order_units_key",
    grouping: "Units",
  },
  {
    name: "Revenue (Direct)",
    id: "revenue_direct",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "revenue_direct_key",
    grouping: "Revenue",
  },
  {
    name: "Revenue (Indirect)",
    id: "revenue_indirect",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "revenue_indirect_key",
    grouping: "Revenue",
  },
  {
    name: "Ads Revenue",
    id: "revenue",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "revenue_key",
    grouping: "Revenue",
  },
  {
    name: "Total Revenue (GMV)",
    id: "gmv",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "gmv_key",
    grouping: "Revenue",
  },
  {
    name: "Revenue (Direct) Percentage",
    id: "direct_revenue_percentage",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "direct_revenue_percentage_key",
    grouping: "Revenue",
  },
  {
    name: "Revenue (Indirect) Percentage",
    id: "indirect_revenue_percentage",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "indirect_revenue_percentage_key",
    grouping: "Revenue",
  },
  {
    name: "ROAS Direct",
    id: "direct_roas",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "direct_roas_key",
    grouping: "ROAS",
  },
  {
    name: "Ads ROAS",
    id: "roas",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "roas_key",
    grouping: "ROAS",
  },
  {
    name: "Total ROAS",
    id: "total_roas",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "total_roas_key",
    grouping: "ROAS",
  },
  {
    name: "CPM",
    id: "cpm",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "cpm_key",
    grouping: "CPM",
  },
  {
    name: "Average Order Value",
    id: "aov",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "aov_key",
    grouping: "Average Order Value",
  },
  {
    name: "ACOS",
    id: "acos",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "acos_key",
    grouping: "ACOS",
  },
  // {
  //   name: "Clicks DRR",
  //   id: "clicks_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "clicks_drr_key",
  //   grouping: "Clicks",
  // },
  // {
  //   name: "Spends DRR",
  //   id: "spends_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "spends_drr_key",
  //   grouping: "Spends",
  // },
  // {
  //   name: "CTR DRR",
  //   id: "ctr_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "ctr_drr_key",
  //   grouping: "CTR",
  // },
  // {
  //   name: "CVR DRR",
  //   id: "cvr_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "cvr_drr_key",
  //   grouping: "CVR",
  // },
  // {
  //   name: "Units DRR",
  //   id: "units_sold_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "units_sold_drr_key",
  //   grouping: "Units",
  // },
  // {
  //   name: "Units (Direct) DRR",
  //   id: "units_sold_direct_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "units_sold_direct_drr_key",
  //   grouping: "Units",
  // },
  // {
  //   name: "Units (Indirect) DRR",
  //   id: "units_sold_indirect_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "units_sold_indirect_drr_key",
  //   grouping: "Units",
  // },
  // {
  //   name: "Revenue (Direct) DRR",
  //   id: "revenue_direct_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "revenue_direct_drr_key",
  //   grouping: "Revenue",
  // },
  // {
  //   name: "Revenue (Indirect) DRR",
  //   id: "revenue_indirect_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "revenue_indirect_drr_key",
  //   grouping: "Revenue",
  // },
  // {
  //   name: "ROAS DRR",
  //   id: "roas_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "roas_drr_key",
  //   grouping: "ROAS",
  // },
  // {
  //   name: "CPC DRR",
  //   id: "cpc_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "cpc_drr_key",
  //   grouping: "CPC",
  // },
  // {
  //   name: "Revenue DRR",
  //   id: "revenue_drr",
  //   datatype: "int",
  //   type: "default",
  //   placeholder: "Enter value",
  //   dynamicOptions: false,
  //   autoComplete: true,
  //   source: "Adyogi",
  //   apiKey: "revenue_drr_key",
  //   grouping: "Revenue",
  // },
  {
    name: "Days on Hands (DoH)",
    id: "doh",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "doh_key",
    grouping: "Days on Hands (DoH)",
  },
  {
    name: "Velocity",
    id: "velocity",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "velocity_key",
    grouping: "Velocity",
  },
  {
    name: "Ad Sales per Impression",
    id: "ad_sales_per_impression",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "ad_sales_per_impression_key",
    grouping: "Ad Sales per Impression",
  },
  {
    name: "Revenue per Impression (RPI)",
    id: "rpi",
    datatype: "int",
    type: "default",
    placeholder: "Enter value",
    dynamicOptions: false,
    autoComplete: true,
    source: "Adyogi",
    apiKey: "rpi_key",
    grouping: "Revenue per Impression (RPI)",
  },
]
  },
};

export const FiltersDimensionDataQuadrant = {
  amazon: {
    operators: commonFilterOperators,
    fields: [
      {
        name: "Product Name",
        id: "VariantAnalysisTablePPMPlaceholder.productName",
        datatype: "string",
        type: "default",
        placeholder: "Enter product name",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "product_name_key",
        grouping: "Product Name",
      },
      {
        name: "ASIN",
        id: "VariantAnalysisTablePPMPlaceholder.asin",
        datatype: "string",
        type: "default",
        placeholder: "enter ASIN",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "asin_key",
        grouping: "Product ID",
      },
      {
        name: "Color",
        id: "VariantAnalysisTablePPMPlaceholder.color",
        datatype: "string",
        type: "default",
        placeholder: "enter color",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "color_key",
        grouping: "Color",
      },
      {
        name: "Gender",
        id: "VariantAnalysisTablePPMPlaceholder.gender",
        datatype: "string",
        type: "default",
        placeholder: "enter gender",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "gender_key",
        grouping: "Gender",
      },
      {
        name: "Category",
        id: "VariantAnalysisTablePPMPlaceholder.category",
        datatype: "string",
        type: "default",
        placeholder: "enter category",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "category_key",
        grouping: "Category",
      },
      {
        name: "Pack Type",
        id: "VariantAnalysisTablePPMPlaceholder.packType",
        datatype: "string",
        type: "default",
        placeholder: "enter pack type",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "pack_type_key",
        grouping: "Pack Type",
      },
      {
        name: "Campaign Name",
        id: "VariantAnalysisTablePPMPlaceholder.campaignName",
        datatype: "string",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: true,
        optionsKey: "campaign_names_api_key",
        source: "BackendAll",
        optionsType: "Static",
        dataFromApi: true,
        apiKey: "campaign_names_api_key",
        backendSearch: true,
        grouping: "Campaign Name",
      },
      {
        name: "Portfolio Name",
        id: "VariantAnalysisTablePPMPlaceholder.portfolioName",
        datatype: "string",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: true,
        optionsKey: "portfolio_names_api_key",
        source: "BackendAll",
        optionsType: "Static",
        dataFromApi: true,
        apiKey: "portfolio_names_api_key",
        backendSearch: true,
        grouping: "Portfolio Name",
      },
      {
        name: "Campaign Type",
        id: "VariantAnalysisTablePPMPlaceholder.campaignFormat",
        datatype: "string",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        optionsType: "Static",
        optionsKey: "SP,SD,SB(V),SB",
        grouping: "Campaign Type",
      },
      {
        name: "Campaign Format",
        id: "VariantAnalysisTablePPMPlaceholder.campaignType",
        datatype: "string",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        optionsType: "Static",
        optionsKey: "Prospect,Retarget",
        grouping: "Campaign Format",
      },
      {
        name: "Campaign Status",
        id: "VariantAnalysisTablePPMPlaceholder.campaignStatus",
        datatype: "string",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        optionsType: "Static",
        optionsKey: "PAUSED,ENABLED,ARCHIVED",
        grouping: "Campaign Status",
      },
      {
        name: "Ad Status",
        id: "VariantAnalysisTablePPMPlaceholder.adStatus",
        datatype: "string",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        optionsType: "Static",
        optionsKey: "PAUSED,ENABLED,ARCHIVED",
        grouping: "Ad Status",
      },
      {
        name: "Ad Group Name",
        id: "VariantAnalysisTablePPMPlaceholder.adGroupName",
        datatype: "string",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: true,
        optionsKey: "ad_group_names_api_key",
        source: "BackendAll",
        optionsType: "Static",
        dataFromApi: true,
        apiKey: "ad_group_names_api_key",
        backendSearch: true,
        grouping: "Ad Group Name",
      },
      {
        name: "Product Tag 1",
        id: "VariantAnalysisTablePPMPlaceholder.product_tags",
        datatype: "string",
        type: "default",
        placeholder: "enter Product Tag 1",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "product_tags_key",
        grouping: "Product Tags",
      },
      ...[2,3,4,5,6,7,8,9,10].map((index) => ({
        name: `Product Tag ${index}`,
        id: `VariantAnalysisTablePPMPlaceholder.product_tags_${index}`,
        datatype: "string",
        type: "default",
        placeholder: `enter Product Tag ${index}`,
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: `product_tags_${index}_key`,
        grouping: `Product Tags`,
      })),
    ],
  },
  myntra: {
    operators: commonFilterOperators,
     fields: [
      {
        name: "Product Name",
        id: "product_name",
        datatype: "string",
        type: "default",
        placeholder: "Enter product name",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "product_name_key",
        grouping: "Product Name",
      },
      {
        name: "Style ID",
        id: "product_id",
        datatype: "string",
        type: "default",
        placeholder: "enter Style ID",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "product_id_key",
        grouping: "Product ID",
      },
       {
        name: "Brand Name",
        id: "brand",
        datatype: "string",
        type: "default",
        placeholder: "enter brand",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "brand_key",
        grouping: "Brand Name",
      },
      {
        name: "Listing Category",
        id: "listing_category",
        datatype: "string",
        type: "default",
        placeholder: "enter category",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "listing_category_key",
        grouping: "Category",
      },
      {
        name: "Category",
        id: "category",
        datatype: "string",
        type: "default",
        placeholder: "enter category",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "category_key",
        grouping: "Category",
      },
      {
        name: "Collection",
        id: "collection",
        datatype: "string",
        type: "default",
        placeholder: "enter collection",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "collection_key",
        grouping: "Collection",
      },
      {
        name: "Seller Type",
        id: "seller",
        datatype: "string",
        type: "default",
        placeholder: "enter seller",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "seller_key",
        grouping: "Seller Type",
      },
      {
        name: "Inventory",
        id: "inventory",
        datatype: "int",
        type: "default",
        placeholder: "enter inventory",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "inventory_key",
        grouping: "Inventory",
      },
      {
        name: "Color",
        id: "color",
        datatype: "string",
        type: "default",
        placeholder: "enter color",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "color_key",
        grouping: "Color",
      },
      {
        name: "Key Name",
        id: "key_name",
        datatype: "string",
        type: "default",
        placeholder: "enter key name",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "key_name_key",
        grouping: "Key Name",
      },
      {
        name: "Listing Price",
        id: "listing_price",
        datatype: "int",
        type: "default",
        placeholder: "enter listing price",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "listing_price_key",
        grouping: "Listing Price",
      },
      {
        name: "Listing MRP",
        id: "listing_mrp",
        datatype: "int",
        type: "default",
        placeholder: "enter listing MRP",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "listing_mrp_key",
        grouping: "MRP",
      },
      {
        name: "Article Type",
        id: "article_type",
        datatype: "string",
        type: "default",
        placeholder: "enter article type",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "article_type_key",
        grouping: "Article Type",
      },
      {
        name: "Channel",
        id: "channel",
        datatype: "string",
        type: "default",
        placeholder: "enter channel",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "channel_key",
        grouping: "Channel",
      },
      {
        name: "Order MRP",
        id: "stats_mrp",
        datatype: "int",
        type: "default",
        placeholder: "enter Order MRP",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "stats_mrp_key",
        grouping: "MRP",
      },
      {
        name: "Listing Size",
        id: "listing_size",
        datatype: "string",
        type: "default",
        placeholder: "enter size",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "listing_size_key",
        grouping: "Size",
      },
      {
        name: "Size",
        id: "size",
        datatype: "string",
        type: "default",
        placeholder: "enter size",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "size_key",
        grouping: "Size",
      },
      {
        name: "Seller SKU Code",
        id: "seller_sku_code",
        datatype: "string",
        type: "default",
        placeholder: "enter seller sku code",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "seller_sku_code_key",
        grouping: "Seller SKU Code",
      },
      {
        name: "Base Colour",
        id: "base_colour",
        datatype: "string",
        type: "default",
        placeholder: "enter base colour",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "base_colour_key",
        grouping: "Base Colour",
      },
      {
        name: "Listing Gender",
        id: "listing_gender",
        datatype: "string",
        type: "default",
        placeholder: "enter gender",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "listing_gender_key",
        grouping: "Gender",
      },
      {
        name: "Gender",
        id: "gender",
        datatype: "string",
        type: "default",
        placeholder: "enter gender",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "gender_key",
        grouping: "Gender",
      },
      {
        name: "Master Category",
        id: "master_category",
        datatype: "string",
        type: "default",
        placeholder: "enter master category",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "master_category_key",
        grouping: "Master Category",
      },
      {
        name: "Product Tag 1",
        id: "product_tags",
        datatype: "string",
        type: "default",
        placeholder: "enter Product Tag 1",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "product_tags_key",
        grouping: "Product Tags",
      },
      ...[2,3,4,5,6,7,8,9,10].map((index) => ({
        name: `Product Tag ${index}`,
        id: `product_tags_${index}`,
        datatype: "string",
        type: "default",
        placeholder: `enter Product Tag ${index}`,
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: `product_tags_${index}_key`,
        grouping: `Product Tags`,
      })),
    ],
  },
  flipkart: {
    operators: commonFilterOperators,
    fields: [
      {
        name: "Product Name",
        id: "product_name",
        datatype: "string",
        type: "default",
        placeholder: "Enter product name",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "product_name_key",
        grouping: "Product Name",
      },
      {
        name: "FSN ID",
        id: "product_id",
        datatype: "string",
        type: "default",
        placeholder: "enter FSN ID",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "product_id_key",
        grouping: "Product ID",
      },
      {
        name: "Brand Name",
        id: "brand",
        datatype: "string",
        type: "default",
        placeholder: "enter brand",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "brand_key",
        grouping: "Brand Name",
      },
      {
        name: "Category",
        id: "category",
        datatype: "string",
        type: "default",
        placeholder: "enter category",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "category_key",
        grouping: "Category",
      },
      {
        name: "Collection",
        id: "collection",
        datatype: "string",
        type: "default",
        placeholder: "enter collection",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "collection_key",
        grouping: "Collection",
      },
      {
        name: "Seller Type",
        id: "seller",
        datatype: "string",
        type: "default",
        placeholder: "enter seller",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "seller_key",
        grouping: "Seller Type",
      },
      {
        name: "Gender",
        id: "gender",
        datatype: "string",
        type: "default",
        placeholder: "enter gender",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "gender_key",
        grouping: "Gender",
      },
      {
        name: "Inventory",
        id: "inventory",
        datatype: "int",
        type: "default",
        placeholder: "enter inventory",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "inventory_key",
        grouping: "Inventory",
      },
      {
        name: "Size",
        id: "size",
        datatype: "string",
        type: "default",
        placeholder: "enter size",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "size_key",
        grouping: "Size",
      },
      {
        name: "Color",
        id: "color",
        datatype: "string",
        type: "default",
        placeholder: "enter color",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "color_key",
        grouping: "Color",
      },
      {
        name: "Key Name",
        id: "key_name",
        datatype: "string",
        type: "default",
        placeholder: "enter key name",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "key_name_key",
        grouping: "Key Name",
      },
      {
        name: "Listing Price",
        id: "listing_price",
        datatype: "int",
        type: "default",
        placeholder: "enter listing price",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "listing_price_key",
        grouping: "Listing Price",
      },
      {
        name: "Listing MRP",
        id: "listing_mrp",
        datatype: "int",
        type: "default",
        placeholder: "enter listing MRP",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "listing_mrp_key",
        grouping: "MRP",
      },
      {
        name: "Article Type",
        id: "article_type",
        datatype: "string",
        type: "default",
        placeholder: "enter article type",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "article_type_key",
        grouping: "Article Type",
      },
      {
        name: "Channel",
        id: "channel",
        datatype: "string",
        type: "default",
        placeholder: "enter channel",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "channel_key",
        grouping: "Channel",
      },
      {
        name: "Order MRP",
        id: "stats_mrp",
        datatype: "int",
        type: "default",
        placeholder: "enter Order MRP",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "stats_mrp_key",
        grouping: "MRP",
      },
      {
        name: "Product Tag 1",
        id: "product_tags",
        datatype: "string",
        type: "default",
        placeholder: "enter Product Tag 1",
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: "product_tags_key",
        grouping: "Product Tags",
      },
      ...[2,3,4,5,6,7,8,9,10].map((index) => ({
        name: `Product Tag ${index}`,
        id: `product_tags_${index}`,
        datatype: "string",
        type: "default",
        placeholder: `enter Product Tag ${index}`,
        dynamicOptions: false,
        autoComplete: true,
        source: "Adyogi",
        apiKey: `product_tags_${index}_key`,
        grouping: `Product Tags`,
      })),
    ],
  },
};

export const FiltersCampaignDataQuadrant = {
  amazon: {
    operators: commonFilterOperators,
    fields: [
      {
        name: "Category Name",
        id: "VariantAnalysisTablePPMPlaceholder.category",
        datatype: "string",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: true,
        optionsKey: "category_names_api_key",
        source: "BackendAll",
        optionsType: "Static",
        dataFromApi: true,
        apiKey: "category_names_api_key",
      },
      {
        name: "Campaign Name",
        id: "VariantAnalysisTablePPMPlaceholder.campaignName",
        datatype: "string",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: true,
        optionsKey: "campaign_names_api_key",
        source: "BackendAll",
        optionsType: "Static",
        dataFromApi: true,
        apiKey: "campaign_names_api_key",
      },
      {
        name: "Portfolio Name",
        id: "VariantAnalysisTablePPMPlaceholder.portfolioName",
        datatype: "string",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: true,
        optionsKey: "portfolio_names_api_key",
        source: "BackendAll",
        optionsType: "Static",
        dataFromApi: true,
        apiKey: "portfolio_names_api_key",
      },
      {
        name: "Product Set",
        id: "VariantAnalysisTablePPMPlaceholder.productSet",
        datatype: "string",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: true,
        optionsKey: "product_set_api_key",
        source: "BackendAll",
        optionsType: "Static",
        dataFromApi: true,
        apiKey: "product_set_api_key",
      },
      {
        name: "Campaign Type",
        id: "VariantAnalysisTablePPMPlaceholder.campaignFormat",
        datatype: "string",
        type: "default",
        placeholder: "Select a type",
        dynamicOptions: true,
        optionsKey: "SP,SD,SB(V),SB",
        optionsType: "Static",
        source: "Adyogi",
        apiKey: "campaign_format_key",
      },
      {
        name: "Campaign Format",
        id: "VariantAnalysisTablePPMPlaceholder.campaignType",
        datatype: "string",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: true,
        optionsKey: "Prospect,Retarget",
        optionsType: "Static",
        source: "Adyogi",
        apiKey: "campaignType_id_key",
      },
      {
        name: "Targeting Type",
        id: "VariantAnalysisTablePPMPlaceholder.targetingType",
        datatype: "string",
        type: "default",
        placeholder: "Select targeting type",
        dynamicOptions: true,
        optionsKey:
          "G.Keyword,C.Keyword,NB.Keyword,Audience,Automatic,NB.Product,B.Keyword,B.Audience,B.Product",
        optionsType: "Static",
        source: "Adyogi",
        apiKey: "targeting_type_key",
      },
      {
        name: "Ad Status",
        id: "VariantAnalysisTablePPMPlaceholder.adStatus",
        datatype: "string",
        type: "default",
        placeholder: "Select ad status",
        dynamicOptions: true,
        optionsKey: "enabled,paused",
        optionsType: "Static",
        source: "Adyogi",
        apiKey: "ad_status_key",
      },
      {
        name: "Ad Group Name",
        id: "VariantAnalysisTablePPMPlaceholder.adGroupName",
        datatype: "string",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: true,
        optionsKey: "ad_group_names_api_key",
        source: "BackendAll",
        optionsType: "Static",
        dataFromApi: true,
        apiKey: "ad_group_names_api_key",
      },
    ],
  },
  myntra: {
    operators: commonFilterOperators,
    fields: [
      {
        name: "Campaign Name",
        id: "campaign_name",
        datatype: "string",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: true,
        source: "Adyogi",
        optionsType: "Static",
        dataFromApi: true,
        apiKey: "campaign_names_key",
      },
      {
        name: "Campaign ID",
        id: "campaign_id",
        datatype: "string",
        type: "default",
        placeholder: "enter campaign id",
        dynamicOptions: true,
        source: "Adyogi",
        optionsType: "Static",
        dataFromApi: true,
        apiKey: "campaign_id_key",
      },
      {
        name: "Campaign Status",
        id: "campaign_status",
        datatype: "string",
        type: "default",
        placeholder: "enter campaign status",
        dynamicOptions: true,
        source: "Adyogi",
        optionsType: "Static",
        dataFromApi: true,
        apiKey: "campaign_status_key",
      },
      {
        name: "Ad Group Name",
        id: "ad_group_name",
        datatype: "string",
        type: "default",
        placeholder: "Enter ad group name",
        dynamicOptions: true,
        optionsType: "Static",
        source: "Adyogi",
        apiKey: "ad_group_name_key",
      },
      {
        name: "Ad Group ID",
        id: "ad_group_id",
        datatype: "string",
        type: "default",
        placeholder: "enter ad group ID",
        dynamicOptions: true,
        optionsType: "Static",
        source: "Adyogi",
        apiKey: "ad_group_id_key",
      },
      {
        name: "Ad Group Status",
        id: "ad_group_status",
        datatype: "string",
        type: "default",
        placeholder: "enter ad group Status",
        dynamicOptions: true,
        optionsType: "Static",
        source: "Adyogi",
        apiKey: "ad_group_status_key",
      },
    ],
  },
  flipkart: {
    operators: commonFilterOperators,
    fields: [
      {
        name: "Campaign Name",
        id: "campaign_name",
        datatype: "string",
        type: "default",
        placeholder: "Enter value",
        dynamicOptions: true,
        source: "Adyogi",
        optionsType: "Static",
        dataFromApi: true,
        apiKey: "campaign_names_key",
      },
      {
        name: "Campaign ID",
        id: "campaign_id",
        datatype: "string",
        type: "default",
        placeholder: "enter campaign id",
        dynamicOptions: true,
        source: "Adyogi",
        optionsType: "Static",
        dataFromApi: true,
        apiKey: "campaign_id_key",
      },
      {
        name: "Campaign Type",
        id: "campaign_type",
        datatype: "string",
        type: "default",
        placeholder: "enter campaign type",
        dynamicOptions: true,
        source: "Adyogi",
        optionsType: "Static",
        dataFromApi: true,
        apiKey: "campaign_type_key",
      },
      {
        name: "Ad Group Name",
        id: "ad_group_name",
        datatype: "string",
        type: "default",
        placeholder: "Enter ad group name",
        dynamicOptions: true,
        optionsType: "Static",
        source: "Adyogi",
        apiKey: "ad_group_name_key",
      },
      {
        name: "Ad Group ID",
        id: "ad_group_id",
        datatype: "string",
        type: "default",
        placeholder: "enter ad group ID",
        dynamicOptions: true,
        optionsType: "Static",
        source: "Adyogi",
        apiKey: "ad_group_id_key",
      },
    ],
  },
};


export const useTopXDataConfig = () => {
  const userPlatform = JSON.parse(localStorage.getItem("user_platform"));
  
  return {
    operators: {int: [
      { id: "TOP", name: "Top",multiple:false },
      { id: "BOTTOM", name: "Bottom",multiple:false }
    ]},
    fields: updatePlaceholders(FiltersMeasuresDataQuadrant[userPlatform].fields)
  }
}

export const PlatformWiseQueryMeasures = {
  amazon: [
    "VariantAnalysisTablePPMPlaceholder.cost",
    // "VariantAnalysisTablePPMPlaceholder.costDRR",
    "VariantAnalysisTablePPMPlaceholder.SalePrice",
    "VariantAnalysisTablePPMPlaceholder.Quantity",
    "VariantAnalysisTablePPMPlaceholder.impressions",
    // "VariantAnalysisTablePPMPlaceholder.impressionsDRR",
    "VariantAnalysisTablePPMPlaceholder.clicks",
    // "VariantAnalysisTablePPMPlaceholder.clicksDRR",
    "VariantAnalysisTablePPMPlaceholder.ctr",
    // "VariantAnalysisTablePPMPlaceholder.ctrDRR",
    "VariantAnalysisTablePPMPlaceholder.cpc",
    // "VariantAnalysisTablePPMPlaceholder.cpcDRR",
    "VariantAnalysisTablePPMPlaceholder.cpm",
    // "VariantAnalysisTablePPMPlaceholder.cpmDRR",
    "VariantAnalysisTablePPMPlaceholder.conversions14d",
    // "VariantAnalysisTablePPMPlaceholder.conversions14dDRR",
    "VariantAnalysisTablePPMPlaceholder.conversion_rate",
    // "VariantAnalysisTablePPMPlaceholder.conversion_rateDRR",
    "VariantAnalysisTablePPMPlaceholder.sales14d",
    // "VariantAnalysisTablePPMPlaceholder.sales14dDRR",
    "VariantAnalysisTablePPMPlaceholder.average_order_value",
    // "VariantAnalysisTablePPMPlaceholder.average_order_valueDRR",
    "VariantAnalysisTablePPMPlaceholder.acos",
    // "VariantAnalysisTablePPMPlaceholder.acosDRR",
    "VariantAnalysisTablePPMPlaceholder.roas",
    // "VariantAnalysisTablePPMPlaceholder.roasDRR",
    "VariantAnalysisTablePPMPlaceholder.MaximumRetailPrice",
    "VariantAnalysisTablePPMPlaceholder.BSR",
    "VariantAnalysisTablePPMPlaceholder.total_asp",
    "VariantAnalysisTablePPMPlaceholder.troas",
    "VariantAnalysisTablePPMPlaceholder.tacos",
    "VariantAnalysisTablePPMPlaceholder.trevnue",
    "VariantAnalysisTablePPMPlaceholder.tunits_sold",
    "VariantAnalysisTablePPMPlaceholder.name",
    "VariantAnalysisTablePPMPlaceholder.image",
    "VariantAnalysisTablePPMPlaceholder.stop_loss_entity_status",
    "VariantAnalysisTablePPMPlaceholder.adStatusAnyEnabled",
  ],
  amazonCampaignABO: [
      "spends",
      "impressions",
      "clicks",
      "orders",
      "revenue",
      "roas",
      "ctr",
      "cpc",
      "cpm",
      "cvr",
      "aov",
      "acos",
      "date_diff",
      "campaign_id",
      "campaign_name",
  ],
  myntra: [
    // "views",
    // "views_drr",
    "clicks",
    "total_click",
    "clicks_drr",
    "spends",
    "spends_drr",
    "ctr",
    "ctr_drr",
    "cvr",
    "cvr_drr",
    "revenue",
    "units_sold_direct",
    "units_sold_indirect",
    "revenue_direct",
    "revenue_indirect",
    "asp",
    "roas",
    "cpc",
    "units_sold_direct_drr",
    "units_sold_indirect_drr",
    "revenue_direct_drr",
    "revenue_indirect_drr",
    "asp_drr",
    "roas_drr",
    "cpc_drr",
    "impressions",
    "orders",
    "cpm",
    "aov",
    "acos",
    "mrp",
    "direct_roas",
    "direct_revenue_percentage",
    "indirect_revenue_percentage",
    "product_name_measures",
    "total_inventory_count",
    "total_inventory_count_partner",
    "partners_total_orders",
    "partners_total_revenue",
     "gmv",
    "order_units",
    "total_cvr",
    "total_roas",
    "velocity",
    "ad_sales_per_impression",
    "rpi",
    "doh",
    "stop_loss_entity_status"
  ],
  flipkart: [
    "clicks",
    "spends",
    "ctr",
    "cvr",
    "revenue",
    "units_sold_direct",
    "units_sold_indirect",
    "revenue_direct",
    "revenue_indirect",
    "roas",
    "cpc",
    "impressions",
    "orders",
    "cpm",
    "aov",
    "acos",
    "clicks_drr",
    "spends_drr",
    "ctr_drr",
    "cvr_drr",
    "units_sold_drr",
    "units_sold_direct_drr",
    "units_sold_indirect_drr",
    "revenue_direct_drr",
    "revenue_indirect_drr",
    "roas_drr",
    "cpc_drr",
    "revenue_drr",
    "direct_roas",
    "direct_revenue_percentage",
    "indirect_revenue_percentage",
    "gmv",
    "order_units",
    "total_cvr",
    "total_roas",
    "velocity",
    "ad_sales_per_impression",
    "rpi",
    "doh",
    "inventory"
  ],
};

export const PlatformWiseQueryDefaultDimension = {
  amazon: [
    // "VariantAnalysisTablePPMPlaceholder.profileId",
    "VariantAnalysisTablePPMPlaceholder.asin",
    // "VariantAnalysisTablePPMPlaceholder.productNameWithImage",
  ],
  myntra: ["product_id","product_name"],
  flipkart: ["product_id", "product_name"],
};

export const PlatformWiseQueryOrder = {
  amazon: [["VariantAnalysisTablePPMPlaceholder.cost", "desc"]],
  amazonCampaignABO: [["spends", "desc"]],
  myntra: [["spends", "desc"]],
  flipkart: [["spends", "desc"]],
};

export const PlatformWiseKeyMapper = {
  amazon: {
    date: "VariantAnalysisTablePPMPlaceholder.obDate",
    tableName: "VariantAnalysisTablePPMPlaceholder.",
    defaultCampaignBackend: "amazon_campaigns_filter",
    productSetType:"amazon_smart_product_set_v2",
    productSetCreativeType: "amazon_smart_creative",
  },
  amazonCampaignABO: {
    date: "date",
    tableName: "",
    defaultCampaignBackend: "amazon_campaigns_filter",
  },
  myntra: {
    date: "date",
    tableName: "",
    defaultCampaignBackend: "myntra_campaigns_filter",
    productSetType:"myntra_smart_product_set",
    productSetCreativeType: "myntra_smart_creative",
  },
  flipkart: {
    date: "date",
    tableName: "",
    defaultCampaignBackend: "flipkart_campaigns_filter",
    productSetType:"flipkart_smart_product_set",
    productSetCreativeType: "flipkart_smart_creative",
  },
};

export const GroupByOptionsDataConfig = {
  amazon: [
    { label: "Child Product (ASIN)", value: "child_product", dimensions: ["VariantAnalysisTablePPMPlaceholder.asin"]},
    { label: "Campaign", value: "campaign", dimensions: [
      "VariantAnalysisTablePPMPlaceholder.campaignId",
      "VariantAnalysisTablePPMPlaceholder.campaignName",
    ] },
    { label: "Ad Group", value: "ad_group", dimensions: [
      "VariantAnalysisTablePPMPlaceholder.campaignId",
      "VariantAnalysisTablePPMPlaceholder.campaignName",
      "VariantAnalysisTablePPMPlaceholder.adGroupId",
      "VariantAnalysisTablePPMPlaceholder.adGroupName",
    ] },
    { label: "Portfolio", value: "portfolio", dimensions: [
      "VariantAnalysisTablePPMPlaceholder.portfolioId",
      "VariantAnalysisTablePPMPlaceholder.portfolioName",
    ] },
    { label: "Parent Product (ASIN)", value: "parent_product", dimensions: ["VariantAnalysisTablePPMPlaceholder.parentSku"] },
    { label: "Broad Category", value: "broad_category", dimensions: [
      "VariantAnalysisTablePPMPlaceholder.broadCategory",
      "VariantAnalysisTablePPMPlaceholder.category"
    ] },
    { label: "Detailed Category", value: "detailed_category", dimensions: [
      "VariantAnalysisTablePPMPlaceholder.category"
    ]},
    { label: "Pack Type", value: "VariantAnalysisTablePPMPlaceholder.packType", dimensions: ["VariantAnalysisTablePPMPlaceholder.packType"] },
    { label: "Product Tag 1", value: "VariantAnalysisTablePPMPlaceholder.product_tags", dimensions: ["VariantAnalysisTablePPMPlaceholder.product_tags"] },
    { label: "Product Tag 2", value: "VariantAnalysisTablePPMPlaceholder.product_tags_2", dimensions: ["VariantAnalysisTablePPMPlaceholder.product_tags_2"] },
    { label: "Product Tag 3", value: "VariantAnalysisTablePPMPlaceholder.product_tags_3", dimensions: ["VariantAnalysisTablePPMPlaceholder.product_tags_3"] },
    { label: "Product Tag 4", value: "VariantAnalysisTablePPMPlaceholder.product_tags_4", dimensions: ["VariantAnalysisTablePPMPlaceholder.product_tags_4"] },
    { label: "Product Tag 5", value: "VariantAnalysisTablePPMPlaceholder.product_tags_5", dimensions: ["VariantAnalysisTablePPMPlaceholder.product_tags_5"] },
    { label: "Product Tag 6", value: "VariantAnalysisTablePPMPlaceholder.product_tags_6", dimensions: ["VariantAnalysisTablePPMPlaceholder.product_tags_6"] },
    { label: "Product Tag 7", value: "VariantAnalysisTablePPMPlaceholder.product_tags_7", dimensions: ["VariantAnalysisTablePPMPlaceholder.product_tags_7"] },
    { label: "Product Tag 8", value: "VariantAnalysisTablePPMPlaceholder.product_tags_8", dimensions: ["VariantAnalysisTablePPMPlaceholder.product_tags_8"] },
    { label: "Product Tag 9", value: "VariantAnalysisTablePPMPlaceholder.product_tags_9", dimensions: ["VariantAnalysisTablePPMPlaceholder.product_tags_9"] },
    { label: "Product Tag 10", value: "VariantAnalysisTablePPMPlaceholder.product_tags_10", dimensions: ["VariantAnalysisTablePPMPlaceholder.product_tags_10"] },
  ],
  myntra: [
    { label: "Product Name", value: "product_id", dimensions: ["product_id","product_name"] },
    { label: "Article", value: "article_type", dimensions: ["article_type"] },
    { label: "Collection", value: "collection", dimensions: ["collection"] },
    { label: "Category", value: "category", dimensions: ["category"] },
    { label: "Brand", value: "brand", dimensions: ["brand"] },
    { label: "Size", value: "size", dimensions: ["size"] },
    { label: "Seller", value: "seller", dimensions: ["seller"] },
    { label: "Gender", value: "gender", dimensions: ["gender"] },
    { label: "Color", value: "color", dimensions: ["color"] },
    { label: "Channel", value: "channel", dimensions: ["channel"] },
    { label: "Product Tag 1", value: "product_tags", dimensions: ["product_tags"] },
    { label: "Product Tag 2", value: "product_tags_2", dimensions: ["product_tags_2"] },
    { label: "Product Tag 3", value: "product_tags_3", dimensions: ["product_tags_3"] },
    { label: "Product Tag 4", value: "product_tags_4", dimensions: ["product_tags_4"] },
    { label: "Product Tag 5", value: "product_tags_5", dimensions: ["product_tags_5"] },
    { label: "Product Tag 6", value: "product_tags_6", dimensions: ["product_tags_6"] },
    { label: "Product Tag 7", value: "product_tags_7", dimensions: ["product_tags_7"] },
    { label: "Product Tag 8", value: "product_tags_8", dimensions: ["product_tags_8"] },
    { label: "Product Tag 9", value: "product_tags_9", dimensions: ["product_tags_9"] },
    { label: "Product Tag 10", value: "product_tags_10", dimensions: ["product_tags_10"] },

  ],
  flipkart: [
    { label: "Product Name", value: "product_id", dimensions: ["product_id", "product_name"] },
    { label: "Article", value: "article_type", dimensions: ["article_type"] },
    { label: "Collection", value: "collection", dimensions: ["collection"] },
    { label: "Category", value: "category", dimensions: ["category"] },
    { label: "Brand", value: "brand", dimensions: ["brand"] },
    { label: "Size", value: "size", dimensions: ["size"] },
    { label: "Seller", value: "seller", dimensions: ["seller"] },
    { label: "Gender", value: "gender", dimensions: ["gender"] },
    { label: "Color", value: "color", dimensions: ["color"] },
    { label: "Channel", value: "channel", dimensions: ["channel"] },
    { label: "Product Tag 1", value: "product_tags", dimensions: ["product_tags"] },
    { label: "Product Tag 2", value: "product_tags_2", dimensions: ["product_tags_2"] },
    { label: "Product Tag 3", value: "product_tags_3", dimensions: ["product_tags_3"] },
    { label: "Product Tag 4", value: "product_tags_4", dimensions: ["product_tags_4"] },
    { label: "Product Tag 5", value: "product_tags_5", dimensions: ["product_tags_5"] },
    { label: "Product Tag 6", value: "product_tags_6", dimensions: ["product_tags_6"] },
    { label: "Product Tag 7", value: "product_tags_7", dimensions: ["product_tags_7"] },
    { label: "Product Tag 8", value: "product_tags_8", dimensions: ["product_tags_8"] },
    { label: "Product Tag 9", value: "product_tags_9", dimensions: ["product_tags_9"] },
    { label: "Product Tag 10", value: "product_tags_10", dimensions: ["product_tags_10"] },
  ]
};